import { render, staticRenderFns } from "./PrintOrderSppb.vue?vue&type=template&id=0c4e50d0&"
import script from "./PrintOrderSppb.vue?vue&type=script&lang=js&"
export * from "./PrintOrderSppb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports